/* eslint-disable indent */
import { FC, memo } from 'react'

import { CheckCircle, Doctor, UserFolder, DoctorWoman, UserBadge } from 'components/icons'
import { Tooltip, Box } from '@chakra-ui/react'

type Props = {
  hasAvailability?: boolean
  label?: string
  context?: string
}

const AvailabilityIcon: FC<Props> = ({ hasAvailability, label = 'Disponível', context = '' }) => {
  if (!hasAvailability) return <></>

  const Icon = () => {
    switch (context.toUpperCase()) {
      case 'ATTENDANCE':
        return <Doctor color="dark" />
      case 'FIELD':
        return <UserBadge color="dark" />
      case 'ONLINE':
        return <DoctorWoman color="dark" />
      case 'CASE-TRACKING':
        return <UserFolder color="dark" />
      default:
        return <CheckCircle color="dark" />
    }
  }

  return (
    <Tooltip label={label}>
      <Box>
        <Icon />
      </Box>
    </Tooltip>
  )
}

export default memo(AvailabilityIcon)
